import React from 'react';
import { MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';

// ###### PLACEHOLDER — feature ainda não implementada.
// Segue o mesmo padrão de placeholder usado em health_main.js (tab "professionals").
const TabExplore = () => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow flex-1 flex flex-col items-center justify-center text-center gap-2 min-h-[240px]">
      <MagnifyingGlassCircleIcon className="h-10 w-10 text-gray-300" />
      <h2 className="text-xl font-semibold text-gray-800">Explore</h2>
      <p className="text-gray-600">Discover new destinations, recommendations and travel ideas will be here.</p>
    </div>
  );
};

export default TabExplore;
